import React from "react";
import { Route, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import { isLoggedIn, getType } from "./authentication";

const SuperAdminRoute = ({ component: Component, ...rest }, replace) => (
  <Route
    {...rest}
    render={(props) =>
      isLoggedIn() === true && getType() === "SuperAdmin" ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: "/admin/login",
            state: { from: props.location },
          }}
        />
      )
    }
  />
);

SuperAdminRoute.propTypes = {
  component: PropTypes.func.isRequired,
};

export default SuperAdminRoute;
